export default __webpack_public_path__ + "static/media/Logo-9Round.49d328f8.jpg";